// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1J2MY","rootSmall":"AddTileButton_rootSmall__11ZGx"};